import { z } from 'zod';
// =========================================================
// Roles definidos en la App Registration (Entra ID).
// Mantener sincronizado con api/src/auth/middleware.ts.
// =========================================================
// NOTA: 'OperadorFiori' NO forma parte de estos App Roles de Entra ID —
// esos choferes no tienen cuenta Microsoft, se autentican por PIN propio
// (ver fiori-pin-dominio.ts / RolApp en tipos/coladas no aplica). El rol
// 'OperadorFiori' igual existe como string de rol en el JWT que emite ese
// login PIN, y el middleware/API lo reconocen igual — solo no se gestiona
// desde /admin/usuarios (que es asignación de App Roles de Entra).
export const ROLES_APP = ['Admin', 'Operador', 'Laboratorio', 'Ingenieria'];
export const RolAppSchema = z.enum(ROLES_APP);
// =========================================================
// GET /api/usuarios — búsqueda de usuarios del tenant (Entra ID)
// =========================================================
// Si `q` viene vacío, se devuelven los usuarios que YA tienen al menos un
// rol asignado en la app (vista por defecto al abrir la pantalla admin).
// Si viene con texto, se busca por displayName / mail / userPrincipalName
// vía Microsoft Graph.
export const ListarUsuariosRequestSchema = z.object({
    q: z.string().trim().min(1).max(100).optional(),
    /** Máximo de usuarios a devolver. */
    limite: z.coerce.number().int().min(1).max(50).default(25),
});
/**
 * Item de la lista de usuarios — incluye los roles que tiene asignados en
 * NUESTRA app (no en el tenant completo, eso son cientos).
 */
export const UsuarioConRolesSchema = z.object({
    /** Object ID del user en Entra ID. */
    oid: z.string().min(1),
    nombre: z.string(),
    email: z.string(),
    /**
     * Roles asignados. Cada uno trae el assignmentId que Graph necesita para
     * borrarlo después (no es el roleId — es el id de la asignación user↔role).
     */
    roles: z.array(z.object({
        rol: RolAppSchema,
        assignmentId: z.string(),
    })),
});
export const ListaUsuariosResponseSchema = z.object({
    usuarios: z.array(UsuarioConRolesSchema),
});
// =========================================================
// POST /api/usuarios/{userId}/asignar-rol
// =========================================================
export const AsignarRolRequestSchema = z.object({
    rol: RolAppSchema,
});
// =========================================================
// DELETE /api/usuarios/{userId}/asignaciones/{assignmentId}
// =========================================================
// (sin body, params en URL).
//# sourceMappingURL=usuarios.js.map